module.exports = __webpack_public_path__ + "media/images/downvote-97989bef4509aba4f9941b9dd9a59d4c.svg";